import {Attachment} from '../message/Attachment';

export class AttachmentWrapper {
entity: Attachment;
method: string;
}

